import React, { useState } from 'react';
import { func, instanceOf, bool, shape } from 'prop-types';

import { connect } from 'react-redux';
import TargetDashboard from './TargetDashboard';
import ImportDefination from './ImportDefination';
import Reports from './Reports';
import { resetDefinitionListState } from '../../../actions/deActions/deImportDefActions';

const TargetView = ({ deStudies, resetDefinitionListState, internalAdmin }) => {
  const [view, setView] = useState('Dashboard');

  const _setView = currentView => {
    if (currentView === 'importDefination') {
      resetDefinitionListState();
    }
    setView(currentView);
  };

  const _renderViews = () => {
    switch (view) {
      case 'Dashboard':
        return <TargetDashboard internalAdmin={internalAdmin} setView={_setView} data-test="Dashboard" />;
      case 'importDefination':
        return (
          <ImportDefination
            deStudies={deStudies}
            setView={_setView}
            data-test="ImportDefination"
          />
        );
      case 'reports':
        return (
          <Reports
            setView={_setView}
            data-test="Reports"
          />
        );
      default:
        return <TargetDashboard data-test="TargetDashboard" />;
    }
  };
  return <React.Fragment>{_renderViews()}</React.Fragment>;
};

TargetView.propTypes = {
  resetDefinitionListState: func,
  deStudies: shape({
    defaultStudy: instanceOf(Object),
    activeStudy: instanceOf(Object),
    loading: bool,
    error: bool,
    data: instanceOf(Array),
  }),
  internalAdmin: bool
};

TargetView.defaultProps = {
  deStudies: {
    defaultStudy: null,
    activeStudy: null,
    loading: true,
    error: false,
    data: [],
  },
  internalAdmin: false
};

const mapStateToProps = ({ deImportDefiniton, login }) => {
  let internalAdmin = false
  if (login.loginResponse && login.loginResponse.data) {
    internalAdmin = login.loginResponse.data.internalAdmin
  }
  return {
    deStudies: deImportDefiniton.studies,
    internalAdmin
  };
};

export default connect(mapStateToProps, {
  resetDefinitionListState,
})(TargetView);
